import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

// Shared building blocks for blog post content.

export function CodeBlock({ language = 'bash', children }) {
  return (
    <SyntaxHighlighter
      language={language}
      style={dracula}
      customStyle={{ borderRadius: '0.75rem', fontSize: '0.875rem', margin: '1.5rem 0' }}
    >
      {children}
    </SyntaxHighlighter>
  );
}

export function Callout({ title, children }) {
  return (
    <aside className="not-prose my-6 rounded-xl border border-accent/30 bg-accent/10 p-5 text-sm text-foreground">
      {title && <p className="font-semibold mb-1">{title}</p>}
      <div className="text-muted-foreground [&_a]:text-accent">{children}</div>
    </aside>
  );
}
